import _ from 'lodash'
import { useStore } from '@tanstack/react-store'

import { LegacyPage, Markdown } from 'peach/components'
import { truncateString } from 'peach/helpers'

import { authStore } from 'core/auth/authStore'

const stringify = (obj) => {
  if (_.isEmpty(obj)) return ''

  return JSON.stringify(obj, null, 2)
}

const code = (str, lang = '') => '```' + lang + '\n' + str + '\n```'

const formatOptions = (options = {}) => {
  if (options?.headers?.Authorization) {
    const { headers, ...restOptions } = options
    const { Authorization, ...restHeaders } = headers
    return {
      ...restOptions,
      headers: {
        ...restHeaders,
        Authorization: truncateString(Authorization, 24),
      },
    }
  }
  return options
}

const ApiCallRequest = (props) => {
  const { fetchArgs } = props

  const { decodedToken } = useStore(authStore)
  const companyId = decodedToken?.company_id
  const userId = decodedToken?.user_id
  const personId = decodedToken?.person_id
  const userType = decodedToken?.user_type

  const [fetchUrl, fetchOptions] = fetchArgs || []

  const options = formatOptions(fetchOptions)

  const codeString = `Session Context: 

- User Type: "${userType || ''}"
- Company Id: "${companyId || ''}"
- User Id: "${userId || ''}"
- Person Id: "${personId || ''}"

Request: 

- URL: '${fetchUrl}'

- Options: 

${stringify(options)}
`

  const markdown = code(codeString, 'yml')

  return (
    <LegacyPage.Full>
      <Markdown markdown={markdown} wrap />
    </LegacyPage.Full>
  )
}

export default ApiCallRequest
